export default "__VITE_ASSET__DSYuAIjq__"